<template>
    <div class="vue-postal-code-survey">
        <ef2-survey-wrapper :webform-id="webformId" @submit="handleSubmit" :survey-event-bus="surveyEventBus" :hide-buttons="showConfirmMessage">
            <template v-if="!showConfirmMessage">
                <div class="form-input survey-question mb-3" v-for="(formItem, index) in form">
                    <label :for="formItem.id">{{ formItem.label }} <template v-if="formItem.required">*</template></label>
                    <input
                        :id="formItem.id"
                        :name="formItem.id"
                        :type="formItem.type"
                        v-model="formItem.value"
                        :required="formItem.required"
                        :placeholder="formItem.placeholder"
                    />
                </div>

                <div class="form-error" v-if="showErrorMessage">
                    <p>{{ errorMessage }}</p>
                </div>
            </template>

            <template v-if="showConfirmMessage">
                <div class="form-error">
                    {{ confirmMessage }}
                </div>
            </template>
        </ef2-survey-wrapper>
    </div>
</template>

<script>
import SurveyMixin from "../../mixins/surveyMixin";

export default {
    name: "PostalCodeSurvey",

    mixins: [SurveyMixin],

    data() {
        return {
            webformId: 'survey_postal_code',
            form: {
                postal_code: {
                    type: "text",
                    label: Drupal.t('What is your postal code?'),
                    placeholder: Drupal.t('Postal code'),
                    id: 'postal-code-question',
                    required: true,
                    value: ""
                }
            }
        }
    },

    computed: {
        mappedFormData() {
            return _.mapValues(this.form, (item) => {
                return item.value
            })
        },

        hasRequiredError() {
            let hasError = false;

            _.forEach(this.form, (item) => {
                if (!item.required) {
                    return
                }

                if (!_.isEmpty(item.value)) {
                    return
                }

                hasError = true;
            })

            return hasError
        }
    },

    created() {
        this.endpoint = '/webform_rest/submit';
        this.getToken();
    },

    methods: {
        handleSubmit() {
            if (this.hasRequiredError) {
                this.showErrorMessage = true;
                return;
            }

            this.showErrorMessage = false;

            axios.post(this.endpoint, {
                    "webform_id": this.webformId,
                    ...this.mappedFormData,
                },
                {
                    headers: {
                        'Accept': "application/json",
                        'Content-Type': "application/json",
                        'X-CSRF-Token': this.csrfToken
                    },
                })
                .then(result => {
                    if (result.status !== 200) {
                        this.errorMessage = Drupal.t("Something wen't wrong please try again later.")
                        this.showErrorMessage = true;
                        return;
                    }

                    this.showConfirmMessage = true;

                    setTimeout(() => {
                        this.surveyEventBus.$emit('survey-finished');
                    }, 3500);
                })
                .catch(error => {
                    this.errorMessage = Drupal.t("Something wen't wrong please try again later.")
                    this.showErrorMessage = true;
                })
        }
    }
}
</script>